import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface FilterUsersResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: {
    id: number;
    userName: string | null;
    email: string | null;
    phoneNumber: string | null;
    createdDate: string | null;
    roleId: number | null;
    roleName: string | null;
  }[];
}

export const filterUsersAsync = async (
  filterType: string,
  pageNumber: number,
  pageSize: number,
  token: string
): Promise<FilterUsersResponse> => {
  const baseUrl = getApiBaseUrl();

  const apiUrl = `${baseUrl}/api/Admin/FilterUsersAsync?filterType=${encodeURIComponent(filterType)}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to filter users");
    }

    return await response.json();
  } catch (error) {
    console.error("Error in filterUsersAsync:", error);
    throw error;
  }
};